import _Object$assign from "babel-runtime/core-js/object/assign";
import _JSON$stringify from "babel-runtime/core-js/json/stringify";
import baseConfig from "../config/baseConfig";
import _storage from "../tools/storage";

if (baseConfig.$basecfg.runtimeType == "mock") {
  var Mock = require("mockjs");

  Mock.mock(baseConfig.$basecfg.httpConfig.baseUrl + "/", "post", function (options) {
    if (options.body) {
      var req = JSON.parse(options.body);
      var reqParams = req.REQUESTS[0].REQ_COMM_DATA;
      var service = reqParams.service;
      delete reqParams["OP_START_TIME"];
      delete reqParams["OPER_TIME"];
      req = _JSON$stringify(req);
      console.warn("This is a mock request, 这是一个模拟请求 " + service);

      var mockData = {};
      var md1 = _storage.$storage.getJsonLocal("_MOCK_DATA");
      if (md1 && !_.isEmpty(md1)) {
        mockData = _Object$assign(mockData, md1);
      }

      var md2 = require("./mockData.json");
      if (md2 && !_.isEmpty(md2)) {
        mockData = _Object$assign(mockData, md2);
      }

      if (mockData.hasOwnProperty(service) && mockData[service].hasOwnProperty(req)) return JSON.parse(mockData[service][req]);else return { "res": { "ANSWERS": [{ "ANS_MSG_HDR": { "MSG_CODE": "-1", "MSG_TEXT": "业务运行失败！" }, "ANS_COMM_DATA": [[], [], { "BPM_DATA": [] }, { "CONFIG": {} }] }] } };
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./src/mock/mock.js
// module id = 1402
// module chunks = 2